import React from 'react';

import TextBase from './TextBase';
import { TBoxProps } from '../Box/Box';

type TAction = {
  as?: TBoxProps['as'];
  color?: string;
};

const Action = ({ as = 'span', color = 'action', ...rest }: TAction) => (
  <TextBase as={as} kind="action" color={color} {...rest} />
);

export default Action;
